<template>
    <div class="my-5">
        <label>{{placeholder}}</label>
        <div>
            <select class="w-full md:w-8/12  p-3 border-b-2 border-light_gray" name="" id="" v-model="input">
                <option v-for="item in items" :key="item.id" :value="item.id">{{item.name}}</option>
            </select>
        </div>
    </div>
</template>
<script>
import { ref } from '@vue/reactivity'
import { watch } from '@vue/runtime-core';
export default {
    props: ['items','value','placeholder'],
    setup(props,{emit}){
        let input = ref(props.value);

        watch(input, value => {
            emit('update:modelValue', value);
        });

        return{
            input
        }
    }
}
</script>
<style>
    
</style>